export default __webpack_public_path__ + "static/media/gsg-logo-logomark.c6702d1b.svg";